<div
  class="mb-4 metric-view h-100"
  [ngClass]="getCustomeClassForWrapper(metric?.metricName)"
>
  <div class="rounded-3 h-100" [ngClass]="getCustomCardClass(metric)">
    <div
      class="card-body overflow-auto"
      [ngClass]="getCustomeCSS(metric?.metricName)"
    >
      <div class="d-flex justify-content-center h-100">
        <ng-container [ngSwitch]="metric?.metricType">
          <app-key-value-card
            *ngSwitchCase="'key_value_card'"
            [data]="metric.data"
          >
          </app-key-value-card>
          <app-defect-severity-distribution
            *ngSwitchCase="'donut_chart'"
            [name]="metric?.name"
            [data]="metric.data"
            [meta]="metric?.meta"
            [metricDisplayName]="metric?.metricDisplayName"
          ></app-defect-severity-distribution>
          <app-pie-chart
            *ngSwitchCase="'pie_chart'"
            [chartType]="'pie'"
            [data]="metric.data"
          ></app-pie-chart>
          <app-bar-chart
            class="w-100 h-100"
            *ngSwitchCase="'bar_chart'"
            [data]="metric"
            [metricDisplayName]="metric?.metricDisplayName"
            [isSeverity]="
              metric?.metricName === 'defectSeverityDistribution' ? true : false
            "
          ></app-bar-chart>
          <app-stacked-chart
            class="w-100 h-100"
            *ngSwitchCase="'stacked_chart'"
            [data]="metric"
          ></app-stacked-chart>
          <app-mind-map *ngSwitchCase="'d3_chart'" [data]="metric.data">
          </app-mind-map>
          <app-line-chart
            class="w-100 h-100"
            *ngSwitchCase="'line_chart'"
            [data]="metric"
          >
          </app-line-chart>
          <app-card-summary
            *ngSwitchCase="'number_card'"
            class="w-100"
            [data]="metric.data"
          ></app-card-summary>
          <app-test-case-performance-view
            class="w-100"
            *ngSwitchCase="'table'"
            [columns]="metric?.columns"
            [data]="metric?.data"
            [config]="metric?.meta[0]"
            [metric]="metric"
          ></app-test-case-performance-view>
          <app-table-view
            *ngSwitchCase="'column_chart'"
            class="w-100"
            [columns]="metric?.columns"
            [data]="metric?.data"
          ></app-table-view>
          <app-risk-indication
            class="w-100 h-100"
            *ngSwitchCase="'risk_indication_chart'"
            [data]="metric?.data"
          >
          </app-risk-indication>
          <app-hotspot-summary
            *ngSwitchCase="'expandable_chart'"
            class="w-100"
            [data]="metric?.data"
            [metricDisplayName]="metric?.metricDisplayName"
          ></app-hotspot-summary>
          <app-card-defect
            *ngSwitchCase="'defect_card'"
            [data]="metric?.data"
            [meta]="metric?.meta[0]"
            [metricDisplayName]="metric?.metricDisplayName"
          ></app-card-defect>
          <app-user-story-details
            *ngSwitchCase="'user_story_detail_card'"
            class="w-100"
            [data]="metric?.data"
          ></app-user-story-details>
          <app-test-case-summary
            *ngSwitchCase="'test_case_summary_card'"
            class="w-100"
            [data]="metric?.data"
            [metricDisplayName]="metric?.metricDisplayName"
          ></app-test-case-summary>
          <app-expandable-detailed-view
            *ngSwitchCase="'expandableDetailedView'"
            class="w-100"
            [data]="metric?.data"
            [meta]="metric?.meta"
            [metricDisplayName]="metric?.metricDisplayName"
            [viewId]="metric?.metricName"
          ></app-expandable-detailed-view>

        </ng-container>
      </div>
    </div>
  </div>
</div>
